


































































































































































































































































































































































import { Component, Vue, Ref } from 'vue-property-decorator';
import * as consts from '../../consts';
import { Sample } from '../../types';
import * as API from '../../store/api';
import moment from 'moment';
import * as helpers from '../../helpers';
import TimeInput from '../../components/dummy/TimeInput.vue';
import Modal from '../../components/spec/Modal.vue';
import DateInput from '../../components/dummy/DateInput.vue';
import MinimalGenericList from '../..//components/spec/MinimalGenericList.vue';
import GenericForm from '../../components/spec/GenericForm.vue';
import RailDeliveryForm from '../../components/spec/RailDeliveryForm.vue';

const INTERNAL = 0;
const EXTERNAL = 1;
const ENEA_CLIENT_ID = 1;

@Component({
  components: {
    TimeInput,
    Modal,
    DateInput,
    MinimalGenericList,
    GenericForm,
    RailDeliveryForm,
  },
})
export default class ModalSampleEdit extends Vue {
  @Ref() readonly modal: Modal;
  @Ref() readonly timeModal: Modal;
  @Ref() readonly resetTime: TimeInput;
  @Ref() readonly resetDate: DateInput;

  enabled = true;
  show = false;
  isNew = false;
  events: [consts.ModalEvents.OK_EVENT, consts.ModalEvents.CANCEL_EVENT];
  params = {};
  revalidate = 0;
  btnSave = 0;
  sample: Sample = null;
  saving = false;
  INTER = INTERNAL;
  EXTER = EXTERNAL;
  chosenRegistration = INTERNAL;
  saveKey = 0;
  takeVisitDate = '';
  takeDateText = '';
  takeTime = '';
  timeInvalidate = 1;
  areaKey = 0;

  dicts = [];

  timeObject: any = {};
  BASIC_PACKAGE_NAME = 'Pakiet podstawowy';

  isPackageAnalysisShown = false;

  selected = [];
  now = moment().format(consts.DATE_FORMAT);
  nowDB = moment().format(consts.DB_DATE_FORMAT);
  items = [];
  user = { first_name: '', last_name: '' };
  itemsWDK = [
    {
      text: 'wykonano',
      sampleType: 'Próbka laboratoryjna (<3,0 mm)',
      sampleAction: 'Wydzielenie 2 próbek o wymaganej masie',
      prepareSymbol: 'WDK_1',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do oznaczania wilgoci całkowitej (<3,0 mm)',
      sampleAction: 'Wydzielenie 1 próbki o wymaganej masie',
      prepareSymbol: 'WDK_2',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do badań (<0,2 mm)',
      sampleAction: 'Suszenie do stałej masy',
      prepareSymbol: 'WDK_3',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do badań (<0,2 mm)',
      sampleAction: 'Mielenie i wydzielenie 1 próbki o wymaganej masie',
      prepareSymbol: 'WDK_4',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do badań (<0,2 mm)',
      sampleAction: 'Przekazanie próbki do SPiO',
      prepareSymbol: 'WDK_5',
    },
  ];
  itemsWN = [
    {
      text: 'wykonano',
      sampleType: 'Próbka laboratoryjna (<2,8 mm)',
      sampleAction: 'Wydzielenie 2 próbek o wymaganej masie',
      prepareSymbol: 'WN_1',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do oznaczania wilgoci całkowitej (<2,8 mm)',
      sampleAction: 'Wydzielenie 1 próbki o wymaganej masie',
      prepareSymbol: 'WN_2',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do badań (<212 μm)',
      sampleAction: 'Suszenie do stałej masy',
      prepareSymbol: 'WN_3',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do badań (<212 μm)',
      sampleAction: 'Mielenie i wydzielenie 1 próbki o wymaganej masie',
      prepareSymbol: 'WN_4',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do badań (<212 μm)',
      sampleAction: 'Przekazanie próbki do SPiO',
      prepareSymbol: 'WN_5',
    },
  ];
  itemsB = [
    {
      text: 'wykonano',
      sampleType: 'Próbka laboratoryjna (<60,0 mm)',
      sampleAction: 'Wydzielenie 2 próbek o wymaganej masie',
      prepareSymbol: 'B_1',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do oznaczania wilgoci całkowitej (<10,0 mm)',
      sampleAction: 'Wydzielenie 1 próbki o wymaganej masie',
      prepareSymbol: 'B_2',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do badań (<1,0 mm)',
      sampleAction: 'Suszenie do stałej masy',
      prepareSymbol: 'B_3',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do badań (<1,0 mm)',
      sampleAction: 'Podział na 2 pod-próbki o wymaganej masie i mielenie',
      prepareSymbol: 'B_4',
    },
    {
      text: 'wykonano',
      sampleType: 'Próbka do badań (<1,0 mm)',
      sampleAction: 'Przekazanie próbki do SPiO',
      prepareSymbol: 'B_5',
    },
  ];

  async showModal(params: any = null) {
    console.log('MethodModal params showModal', params);
    this.sample = params;
    this.selectObject(this.objects.find(o => o.id === this.sample.sample_object_id));
    this.selectSource(this.sources.find(s => s.id === this.sample.source_id));
    const objectTypes = this.objectTypes.find(ot => ot.id === this.sample.object_type_id);
    if (objectTypes) this.selectObjectType(objectTypes);
    this.fillRailDeliveryForm();
    const resp = await API.fetchSampleDates(this.sample.id);
    this.timeObjects = resp.data.sample_dates;
    this.selectedTakeMethod = [];

    let tempArrTM = [];
    // TO-DO: bad solution, we have to fix it
    if (typeof this.sample['take_method'] === 'object') {
      tempArrTM.push(this.sample['take_method']);
    } else if (this.sample['take_methods']) {
      tempArrTM = this.sample['take_methods'];
    }

    tempArrTM.forEach(tm => {
      const dictTM = this.takeMethods.find(takem => takem.id === tm['take_method_id']);
      this.selectedTakeMethod.push(dictTM);
    });

    this.loadTakePlaces();

    this.selectedTakePlace = [];
    let tempArr = [];
    if (typeof this.sample.sample_take_places === 'object') {
      tempArr.push(this.sample.sample_take_places);
    } else {
      tempArr = this.sample['take_places'];
    }
    tempArr.forEach(pl => {
      const dictPL = this.takePlaces.find(takepl => takepl.id === pl['take_place_id']);
      this.selectedTakePlace.push(dictPL);
    });

    const sampleId = params.id;
    const response = await API.fetchPrepareChecklist(sampleId);
    if (response.data.success) {
      this.selected = response.data.selected;
    } else {
      this.selected = [];
    }
    if (
      this.sample.sample_object.value === consts.Objects.WEGIEL &&
      this.sample.source.value === consts.Sources.DOSTAWY_K
    ) {
      this.items = this.itemsWDK;
    }
    if (
      this.sample.sample_object.value === consts.Objects.WEGIEL &&
      this.sample.source.value === consts.Sources.NAWEGL
    ) {
      this.items = this.itemsWN;
    }
    if (this.sample.sample_object.value === consts.Objects.BIOMASA) {
      this.items = this.itemsB;
    } else {
      this.items = this.itemsWDK;
    }
    const user = this.$store.state.currentUser;
    this.items = this.items.map(item => ({
      ...item,
      sampleId: this.sample.id,
      executeUser: user.first_name + ' ' + user.last_name,
      userId: user.id,
      sampleDate: this.now,
      sampleDateDbFormat: this.nowDB,
    }));
    this.show = true;
  }
  async saveModal() {
    this.saving = true;
    this.params['save'] = true;
    this.params['object'] = this.sample;
    this.save();
    this.$emit(consts.ModalEvents.OK_EVENT, this.params);
    this.show = false;
  }
  hideModal() {
    this.params['save'] = this.saving;
    this.$emit(consts.ModalEvents.CANCEL_EVENT, this.params);
    this.show = false;
  }
  /********************* DATE & TIME **********************/
  timeFormParams = [];
  timeObjects = [];
  listDisplay = [];

  get lastDate() {
    if (this.timeObjects.length < 2) {
      if (this.timeObjects[0].date_to) {
        return this.timeObjects[0].date_to;
      } else {
        return null;
      }
    } else return this.getSortedDates[this.timeObjects.length - 1];
  }

  get firstDate() {
    if (this.timeObjects.length === 0) return null;
    return this.getSortedDates[0];
  }

  get getSortedDates() {
    let dts = [];
    this.timeObjects.forEach(el => {
      if (el.date_from) {
        dts.push({ parent: el, date: el.date_from });
      }
      if (el.date_to) {
        dts.push({ parent: el, date: el.date_to });
      }
    });
    dts = dts.sort((a, b) => {
      const diff = moment(a.date, consts.DB_DATE_TIME_FORMAT).diff(moment(b.date, consts.DB_DATE_TIME_FORMAT));
      const secs = moment.duration(diff).asSeconds();
      return secs;
    });
    return dts;
  }

  addTimeObject() {
    const obj = Object.assign({}, this.timeObject);
    obj.localId =
      this.timeObjects.length === 0
        ? 0
        : Math.max(
            ...this.timeObjects.map(el => {
              return el.id;
            })
          ) + 1;

    this.timeObjects.push(obj);
    this.timeObject = {};
    this.timeModal.$forceUpdate();

    for (let i = 1; i <= 4; i++) {
      (this.$refs['reset' + i] as any).reset();
    }

    this.$forceUpdate();
  }

  formatDate(date: string) {
    return moment(date, consts.DB_DATE_TIME_FORMAT).format(consts.DATE_FORMAT);
  }

  /********************* OBJECT **********************/
  objectKey = 0;
  showAdditional = false;
  selectedObject = {};
  get objectValue() {
    return this.selectedObject;
  }
  get objects() {
    return this.dicts ? this.dicts.filter(d => d.type === consts.DictType.OBJECT) : [];
  }
  selectObject(e: KeyboardEvent) {
    this.selectedObject = e;
    this.sources = this.structure
      .filter(s => s.object.id === e['id'])
      .map(s => {
        return { id: s.source.id, value: s.source.value, object: e };
      });
    this.sources = [...new Map(this.sources.map(item => [item['value'], item])).values()];
    this.selectSource(this.sources[0]);
  }

  /********************* SOURCE **********************/
  sources = [];
  selectedSource = {};
  get sourceValue() {
    return this.selectedSource;
  }
  selectSource(e: KeyboardEvent) {
    this.selectedSource = e;
    this.objectTypes = this.structure
      .filter(
        s =>
          s.source.id === e['id'] &&
          s.object.id === e['object']['id'] &&
          s.object_type_id != undefined &&
          s.object_type !== undefined
      )
      .map(s => {
        return { id: s.object_type.id, value: s.object_type.value, object: e['object'], source: e };
      });
    this.objectTypes = [...new Map(this.objectTypes.map(item => [item['value'], item])).values()];
    this.selectObjectType(e);
    this.fillAreas(e);
    this.fillNorms(e);
  }

  /********************* OBJECT TYPE **********************/
  objectTypes = [];
  selectedObjectType = {};
  get objectTypeValue() {
    return this.selectedObjectType;
  }
  selectObjectType(e) {
    this.selectedObjectType = e;
    this.takeMethods = this.structure
      .filter(
        s =>
          s.object_type_id === e['id'] &&
          s.source.id === e['source']['id'] &&
          s.object.id === e['object']['id'] &&
          s.take_method != undefined &&
          s.take_method_id != undefined
      )
      .map(s => {
        return {
          id: s.take_method_id,
          value: s.take_method.value,
          object: e['object'],
          source: e['source'],
          object_type: e,
        };
      });
    this.takeMethods = [...new Map(this.takeMethods.map(item => [item['value'], item])).values()];
  }

  /********************* TAKE METHOD **********************/
  takeMethods = [];
  selectedTakeMethod = [];
  get takeMethodValue() {
    return this.selectedTakeMethod;
  }
  selectTakeMethod(e: KeyboardEvent) {
    console.log('selectTakeMethod', e);
    this.selectedTakeMethod.push(e);
  }

  /********************* TAKE PLACE **********************/
  takePlaces = [];
  selectedTakePlace = [];

  loadTakePlaces() {
    console.log('loadTakePlaces', this.selectedTakeMethod, this.objectTypeValue, this.sourceValue, this.objectValue);
    this.takePlaces = this.structure
      .filter(s => {
        return (
          s.object_type &&
          s.object_type.id === this.objectTypeValue['id'] &&
          s.source &&
          s.source.id === this.sourceValue['id'] &&
          s.object &&
          s.object.id === this.objectValue['id']
        );
      })
      .map(s => {
        return {
          id: s.take_place_id,
          value: s.take_place.value,
          object: this.objectValue,
          source: this.sourceValue,
          object_type: this.objectTypeValue,
          object_methods: this.selectedTakeMethod,
        };
      });
    console.log(
      'loadTakePlaces',
      this.selectedTakeMethod,
      this.objectTypeValue,
      this.sourceValue,
      this.objectValue,
      this.takePlaces
    );

    this.takePlaces = [...new Map(this.takePlaces.map(item => [item['value'], item])).values()];
    this.selectedTakePlace = [];
  }

  get takePlaceValue() {
    return this.selectedTakePlace;
  }
  selectTakePlace(takePlace: any) {
    this.selectedTakePlace.push(takePlace);
  }
  /********************* RAIL DELIVERY **********************/
  mineName = '';
  declaredClass = '';
  arrivalDatetime = '';
  postingDate = '';
  wagonNumber = '';

  fillRailDeliveryForm() {
    this.mineName = this.sample.mine_name;
    this.declaredClass = this.sample.declared_class;
    this.arrivalDatetime = this.sample.arrival_datetime;
    this.postingDate = this.sample.posting_date;
    this.wagonNumber = this.sample.wagon_number;
  }

  /********************* AREA **********************/
  selectedArea = {};
  areas = [];
  get areaValue() {
    return this.selectedArea;
  }
  selectArea(e: KeyboardEvent) {
    this.selectedArea = e;
  }
  fillAreas(e: KeyboardEvent = null) {
    if (this.chosenRegistration === INTERNAL) {
      this.areas = this.structure
        .filter(s => s.source.id === e['id'] && s.object.id === e['object']['id'])
        .map(s => {
          return {
            id: s.area_test_id,
            object: e['object'],
            source: e,
          };
        });
      this.areas = [...new Map(this.areas.map(item => [item['value'], item])).values()];
    } else {
      this.areas = [
        { id: 1, value: 'Regulowany' },
        { id: 2, value: 'NIE-regulowany' },
      ];
    }
    this.selectArea(this.areas[0]);
  }
  /********************* NORMS **********************/
  prepareNorm = {};
  prepareNorms = [];
  recalculateNorm = {};
  recalculateNorms = [];
  fillNorms(e: KeyboardEvent = null) {
    if (this.chosenRegistration === INTERNAL) {
      this.prepareNorms = this.structure
        .filter(s => s.source.id === e['id'] && s.object.id === e['object']['id'])
        .map(s => {
          return {
            id: s.prepare_norm_id,
            object: e['object'],
            source: e,
          };
        });
      this.prepareNorms = [...new Map(this.prepareNorms.map(item => [item['value'], item])).values()];

      this.recalculateNorms = this.structure
        .filter(s => s.source.id === e['id'] && s.object.id === e['object']['id'])
        .map(s => {
          return {
            id: s.recalculate_norm_id,
            object: e['object'],
            source: e,
          };
        });
      this.recalculateNorms = [...new Map(this.recalculateNorms.map(item => [item['value'], item])).values()];
    }
  }

  clientValue = null;
  clients = [];
  analysis = [];
  analyseValue = null;
  choosenAnalysis = [];

  packages = [];
  packageValue = null;
  choosenPackage = null;

  additionalOptions = [
    { name: 0, text: 'NIE' },
    { name: 1, text: 'TAK' },
  ];
  additionalExamValue = this.additionalOptions[0];

  implementationBaseString = '';
  takePersonString = '';
  takeNormString = '';
  takePlaceString = '';
  takeMethodString = '';

  disabledAnalysis = false;
  BASIC_PACKAGE_ID = 1;
  packageSelected(e: any) {
    this.disabledAnalysis = e.id === this.BASIC_PACKAGE_ID ? true : false;
    this.packageValue = this.packages.find(o => o.id === e.id);
  }
  analyseSelected(e: any) {
    this.analyseValue = this.analysis.find(o => o.id === e.id);
  }
  additionalSelected(e: any) {
    this.additionalExamValue = this.additionalOptions.find(o => o.name === e.name);
  }

  clientSelected(e: any) {
    this.clientValue = this.clients.find(o => o.id === e.id);
  }

  onTakeDateContext(ctx) {
    console.log('DATE onTakeDateContext ctx', ctx);
    if (ctx.selectedDate !== null) {
      const dt = moment(
        ctx.selectedFormatted,
        ctx.selectedFormatted.includes('-') ? consts.DB_DATE_TIME_FORMAT : consts.DATE_FORMAT
      );
      if (dt.isValid()) {
        this.takeVisitDate = dt.format(consts.DB_DATE_TIME_FORMAT);
        this.takeDateText = dt.format(consts.DATE_FORMAT);
      }
    }
  }
  modalChooseTakeTimeOK(time: string) {
    console.log('Take time', time);
    this.takeTime = time;
    this.timeInvalidate++;
  }

  choosePackage() {
    this.choosenPackage = this.packageValue;
    this.isPackageAnalysisShown = false;
  }
  addAnalyse() {
    if (!this.choosenAnalysis.includes(this.analyseValue)) {
      this.choosenAnalysis.push(this.analyseValue);
    }
  }
  showPackageAnalysis() {
    this.isPackageAnalysisShown = !this.isPackageAnalysisShown;
  }
  deselectAnalysis(analyse) {
    this.choosenAnalysis = this.choosenAnalysis.filter(a => a.id != analyse.id);
  }
  deselectPackage() {
    this.choosenPackage = null;
  }

  get sampleTests() {
    console.log('typeof this.sample.sample_tests ', typeof this.sample.sample_tests, this.sample.sample_tests);
    if (typeof this.sample.sample_tests === 'object') {
      return [this.sample.sample_tests];
    } else {
      return this.sample.sample_tests;
    }
  }

  async save() {
    this.sample.tests = this.choosenAnalysis;
    this.sample.client_id = this.clientValue.id;

    if (this.choosenPackage) {
      this.sample.package_name = this.choosenPackage.name;
      this.sample['package'] = this.choosenPackage;
    }

    this.sample.wagon_number = this.wagonNumber;
    this.sample.declared_class = this.declaredClass;
    this.sample.mine_name = this.mineName;
    this.sample.arrival_datetime = this.arrivalDatetime;
    this.sample.posting_date = this.postingDate;

    if (this.chosenRegistration === INTERNAL) {
      this.sample.client_type = consts.ClientType.INTERNAL;
      this.sample.sample_object_id = this.objectValue['id'];
      this.sample.object_type_id = this.objectTypeValue['id'];
      this.sample.source_id = this.sourceValue['id'];
      this.sample.take_method_id = this.takeMethodValue['id'];
      this.sample.area_test_id = this.areaValue['id'];
      this.sample.take_method_ids = this.selectedTakeMethod;
      this.sample.take_place_ids = this.selectedTakePlace;
      this.sample.additional = this.additionalExamValue.name === 1;
      if (this.prepareNorms.length > 0) {
        this.sample.prepare_norm_id = this.prepareNorms[0];
      }
      if (this.recalculateNorms.length > 0) {
        this.sample.recalculate_norm_id = this.recalculateNorms[0];
      }
    } else {
      this.sample.client_type = consts.ClientType.EXTERNAL;
      this.sample.sample_object_id = this.objectValue['id'];
      this.sample.object_type_id = this.objectTypeValue['id'];

      this.sample.source_id = null;
      this.sample.take_method_id = null;
      this.sample.area_test_id = null;
      this.sample.take_place_ids = null;
      this.sample.additional = false;
      this.sample.prepare_norm_id = null;
      this.sample.recalculate_norm_id = null;

      this.sample.implementation_base_string = this.implementationBaseString;
      this.sample.take_person_string = this.takePersonString;
      this.sample.take_norm_string = this.takeNormString;
      this.sample.take_place_string = this.takePlaceString;
      this.sample.take_method_string = this.takeMethodString;
    }
    this.sample.sample_dates = this.timeObjects;

    console.log('STATUS', this.sample.status);
    this.sample.status_id = this.sample.status.id;
    console.log('SAMPLE TO SAVE', this.sample);
    const response = await API.saveSample(this.sample);

    if (response.data.success === true) {
      helpers.info('Próbka zapisana!');
    } else {
      helpers.error('Błąd przy zapisie próbki!');
    }

    const selectedItems = this.items.filter(item => this.selected.includes(item.prepareSymbol));
    console.log('CHECKLIST TO SAVE', selectedItems);
    const response_checklist = await API.savePrepareChecklist(selectedItems, this.sample.id);

    if (response_checklist.data.success === true) {
      helpers.info('Czynności przygotowania zapisane!');
    } else {
      helpers.error('Błąd przy zapisie czynności przygotowania!');
    }
  }

  async loadDicts() {
    const response = await API.fetchDicts();
    this.dicts = response.data.dicts;
    console.log('DICTS', this.dicts);
  }

  structure = [];

  async loadStructure() {
    const response = await API.fetchModel('Structure');
    this.structure = response.data.objs;
  }

  async loadClients() {
    const response = await API.fetchClients();
    if (response.data.success === true) {
      if (this.chosenRegistration === EXTERNAL) {
        this.clients = response.data.clients.filter(c => c.id !== ENEA_CLIENT_ID);
      } else {
        this.clients = response.data.clients.filter(c => c.id === ENEA_CLIENT_ID);
      }
      this.clientValue = this.clients[0];
      console.log('CLIENTS:', this.clients);
    }
  }

  async created() {
    console.log('%c*********************** Register creating ***********************', 'color:red');

    this.listDisplay = [
      {
        value: (obj: any) => {
          const dt = obj.date_from;
          if (!dt) {
            return '';
          }
          return moment(dt, consts.DB_DATE_TIME_FORMAT).format(consts.DATE_FORMAT);
        },
        headerName: 'DATA OD',
        columnCss: 'col-3 p-0 text-center',
        headerCss: 'col-3 p-0 text-center',
      },
      {
        value: '$time_from',
        headerName: 'GODZINA OD',
        columnCss: 'col-2 p-0 text-center',
        headerCss: 'col-2 p-0 text-center',
      },
      {
        value: (obj: any) => {
          const dt = obj.date_to;
          if (!dt) {
            return '';
          }
          return moment(dt, consts.DB_DATE_TIME_FORMAT).format(consts.DATE_FORMAT);
        },
        headerName: 'DATA DO',
        columnCss: 'col-3 p-0 text-center',
        headerCss: 'col-3 p-0 text-center',
      },
      {
        value: '$time_to',
        headerName: 'GODZINA DO',
        columnCss: 'col-2 p-0 text-center',
        headerCss: 'col-2 p-0 text-center',
      },
      {
        headerName: 'USUŃ',
        fieldType: 'icon',
        columnCss: 'col-1 p-0 text-center',
        headerCss: 'col-1 p-0 text-center',
        icon: 'times',
        size: 'lg',
        value: 'user',
        css: 'pdf-icon',
        action: async (object: any, e: any) => {
          const index = this.timeObjects.findIndex(el => {
            el.id === object.id;
          });
          this.timeObjects.splice(object.id, 1);
        },
        visible: (obj: any) => {
          return true;
        },
      },
    ];

    this.takeMethods = [];

    await this.loadDicts();
    await this.loadStructure();
    this.selectObject(this.objects[0]);

    let response = await API.fetchPackages();
    if (response.data.success === true) {
      this.packages = response.data.packages;
    }

    response = await API.fetchTests();
    if (response.data.success === true) {
      this.analysis = response.data.tests;
      this.analyseValue = this.analysis[0];
    }

    await this.loadClients();
  }
}
